export const TRANSLATION_NAMESPACE_DEFAULT = 'default'
